var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am-highlighted-vehicle-features"},_vm._l((_vm.features),function(feature){
var _obj;
return _c('div',{key:feature.label},[_c('amui-icon',{class:( _obj = {
        'am-highlighted-vehicle-features__icon': true
      }, _obj['am-highlighted-vehicle-features__icon--' +
        (feature.iconColor || '').toLowerCase()] = feature.iconColor, _obj ),attrs:{"name":feature.icon}}),_vm._v(_vm._s(feature.label)+" ")],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }